import FormattedMessage from 'I18n/components/FormattedMessage';
import { UserTicketStatusOption } from '../data/types';
import { useCloseTicket } from '../data/useCloseTicket';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { XCircleIcon } from 'foundations-assets/icons/components/XCircleIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import I18n from 'I18n';
import { usePortalData } from '../data/usePortalData';
import { jsx as _jsx } from "react/jsx-runtime";
export const CloseTicket = ({
  ticket,
  ticketId
}) => {
  var _portalData$settings;
  const {
    data: portalData
  } = usePortalData();
  const allowTicketClosure = portalData === null || portalData === void 0 || (_portalData$settings = portalData.settings) === null || _portalData$settings === void 0 ? void 0 : _portalData$settings.allowTicketClosure;
  const {
    closeTicket,
    isTicketClosing
  } = useCloseTicket();

  // Do not display button if portal settings disallow closing tickets (also wont render while loading or if error)
  if (!allowTicketClosure) {
    return null;
  }

  // Do not display button if ticket is closed
  if (!ticket || ticket.status !== UserTicketStatusOption.OPEN) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: isTicketClosing ? I18n.text('customer-portal-app.ticketInfoPanel.closing') : undefined,
    children: /*#__PURE__*/_jsx(LoadingButton, {
      "data-test-id": "close-ticket-button",
      use: "primary",
      onClick: () => void closeTicket(Number(ticketId)),
      disabled: isTicketClosing,
      loading: isTicketClosing,
      resultIcon: XCircleIcon,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'customer-portal-app.ticketInfoPanel.close'
      })
    })
  });
};